import { RoleConflictJoin } from "cdes-api/joinDto/RoleConflictJoin";

export class RoleConflictInfo {
    roleConflictJoins : RoleConflictJoin[] = [];
}
